<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-contact">

        <page-title :title="'Kontakt'" :back="true"></page-title>

        <ion-list>
            <div v-for="(item,index) in navigation" :key="item.route" style="background: #f2f2f2">
                <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
                    <ion-item v-show="show" mode="ios" class="ion-activatable" :disabled="item.disabled">
                        <ion-label v-if="item.route.includes('tel:')" mode="md" class="ion-text-wrap">
                            <a :href="item.route">
                                <h3>{{ item.title }}</h3>
                                <p v-if="item.content">{{ item.content }}</p>
                                <!--<svg class="icon icon-chevron-right" style="position: absolute; bottom: 8px; right: -2px; opacity: 0.5"><use xlink:href="#icon-chevron-right"></use></svg>-->
                            </a>
                        </ion-label>
                        <ion-label v-else mode="md" class="ion-text-wrap" @click="goTo(item.route)">
                            <h3>{{ item.title }}</h3>
                            <p v-if="item.content">{{ item.content }}</p>
                            <svg class="icon icon-chevron-right" style="position: absolute; bottom: 8px; right: -2px; opacity: 0.5"><use xlink:href="#icon-chevron-right"></use></svg>
                        </ion-label>
                    </ion-item>
                </slide-x-left-transition>
            </div>
        </ion-list>

        <slide-y-up-transition :duration="700">
            <h3 v-show="show" class="text-center">Dane teleadresowe</h3>
        </slide-y-up-transition>
        <slide-y-up-transition :duration="500" :delay="200">
            <p v-show="show" class="text-center">
                <strong>Kompania Piwowarska S.A</strong><br/>
                Szwajcarska 11<br/>
                61-285 Poznań
            </p>
        </slide-y-up-transition>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import { mapState } from 'vuex';
    import goTo from '@/mixins/goto';

    export default {
        name: 'UserContact',
        components: { PageTitle },
        mixins: [goTo],
        computed: {
            ...mapState({
                navigation: state => state.config.navigation ? state.config.navigation.contact : [],
            }),
        },
        data(){
            return{
                show: false
            }
        },
        mounted(){
            this.show = true;
        },
    }
</script>

<style lang="scss" scoped>
    ion-item,
    ion-list{
        --background: #f2f2f2;
    }
    ion-list{
        padding: 0;
    }
</style>
